import React, { useState } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { Button } from '@getro/rombo';
import { Plus, ChevronDown, ChevronUp } from 'lucide-react';

export const EditableAction = ({ action }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const items = action.items || [];
  const hasMoreThanThree = items.length > 3;
  const visibleItems = isExpanded ? items : items.slice(0, 3);
  const remainingCount = items.length - 3;

  return (
    <Box pl="24px" sx={{ position: 'relative', '&&:hover [data-trigger]': { display: 'flex' } }}>
      <Box
        color="neutral.400"
        sx={{ position: 'absolute', top: '2px', left: 0 }}
        onClick={() => action.extendMethods?.onShowDetailView?.()}
      >
        <Box as={action.icon} width="16px" height="16px" aria-hidden="true" />
      </Box>
      <Box>
        <Flex alignItems="center" sx={{ '&&:hover [data-trigger="true"]': { display: 'block' } }}>
          <Text color="text.subtle" fontSize="14px" mr="4px">
            {action.label}
          </Text>
          {!!action.extendMethods?.onClickAddMore && (
            <Button
              data-trigger="true"
              display="none"
              variant="styleless"
              size="small"
              icon={Plus}
              color="primary"
              fontSize="14px"
              height="auto"
              p="0"
              onClick={action.extendMethods.onClickAddMore}
            >
              Add
            </Button>
          )}
          {!!action.DropdownComponent && (
            <action.DropdownComponent
              trigger={
                <Button
                  data-trigger="true"
                  display="none"
                  variant="styleless"
                  size="small"
                  icon={Plus}
                  color="primary"
                  fontSize="14px"
                  height="auto"
                  p="0"
                >
                  Add
                </Button>
              }
              value={action.items}
              onChange={action.onChange}
              onCreate={action.onCreate}
              placement="bottom-end"
              isLoading={action.isLoading}
              extraOptions={{
                strategy: 'absolute',
              }}
            />
          )}
        </Flex>
        {items.length ? (
          <>
            <Box>
              {visibleItems.map((item) => (
                <action.EditableActionItemComponent
                  key={`editable-action-${item.id}-${item.label}`}
                  isPublic={action.isPublic}
                  item={item}
                  extendMethods={action.extendMethods}
                  onRemove={action.onRemove ? () => action.onRemove(item) : null}
                />
              ))}
            </Box>
            {hasMoreThanThree && (
              <Button
                variant="styleless"
                size="small"
                icon={isExpanded ? ChevronUp : ChevronDown}
                fontSize="12px"
                height="auto"
                p="4px 0"
                onClick={() => setIsExpanded(!isExpanded)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: 'text.dark',
                    textDecoration: 'underline',
                  },
                }}
              >
                {isExpanded ? 'Show less' : `See ${remainingCount} more`}
              </Button>
            )}
          </>
        ) : (
          <Text mt="1" fontSize="1" fontStyle="italic" color="text.subtle">
            None
          </Text>
        )}
      </Box>
    </Box>
  );
};

EditableAction.propTypes = {
  action: PropTypes.object.isRequired,
};
